import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get() {
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const url = `${config.api.paths.locationList}?organisation=${id}`;
        const { data } = yield call(http.authorized.get, url);
        yield put(actionCreators.getSuccess(data));
    } catch (error) {
        logToSentry("On locations get:", { error });
        yield put(actionCreators.getFailure(error));
    }
}

function* patch(action) {
    const { location } = action.payload;
    const url = `${config.api.paths.locations}${location.id}/`;
    try {
        const { data } = yield call(http.authorized.patch, url, location);
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On location patch:", { error });
        yield put(actionCreators.patchFailure(error));
    }
}

function* patchGeo(action) {
    const { location } = action.payload;
    const url = `${config.api.paths.locationsGeoPoints}${location.id}/`;
    try {
        const { data } = yield call(http.authorized.patch, url, location);
        yield put(actionCreators.patchGeoSuccess(data));
    } catch (error) {
        logToSentry("On location geo patch:", { error });
        yield put(actionCreators.patchGeoFailure(error));
    }
}

function* post(action) {
    const { locations } = action.payload;
    try {
        const { id } = yield select((state) => state.userOrganisations.item);
        const next = locations.map((item) => ({ ...item, organisation: id }));
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.locations,
            next
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        console.error(error);
        logToSentry("On locations post:", { error });
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.LOCATIONS_GET_REQUEST, get),
        takeLatest(actionTypes.LOCATION_PATCH_REQUEST, patch),
        takeLatest(actionTypes.LOCATIONS_POST_REQUEST, post),
        takeLatest(actionTypes.LOCATION_PATCH_GEO_REQUEST, patchGeo)
    ]);
}
